import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSyncProblem300 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: "24px",
	viewBox: "0 -960 960 960",
	width: "24px",
	fill: "#1f1f1f",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M142.31-173.08v-60h116.92l-29.07-27.84q-49.31-45.62-70.12-102.12-20.81-56.5-20.81-114.19 0-103.69 60.73-185.96 60.73-82.27 159.27-112.96v63.23q-72.38 28.3-116.19 92.73-43.81 64.42-43.81 142.96 0 46.92 17.77 91.15 17.77 44.23 55.31 81.77l25.38 25.39v-109.54h60v215.38H142.31Zm312.65-121.88q-10.34-10.35-10.34-25.04t10.34-25.04q10.35-10.34 25.04-10.34t25.04 10.34q10.34 10.35 10.34 25.04t-10.34 25.04q-10.35 10.34-25.04 10.34t-25.04-10.34ZM450-435.38V-670h60v234.62h-60Zm150.77 251.53v-63.23q72.38-28.3 116.19-92.73 43.81-64.42 43.81-142.96 0-46.92-17.77-91.15-17.77-44.23-55.31-81.77l-25.38-25.39v109.54h-60v-215.38h215.38v60H700.77l29.07 27.84q47.47 47.47 69.2 103.04 21.73 55.58 21.73 113.27 0 103.69-60.73 185.96-60.73 82.27-159.27 112.96Z" })
});
export default SvgSyncProblem300;
